import { Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import { useLocalization } from 'localization'
import { UploadFile } from 'antd/lib/upload'
import { FC } from 'react'

interface IDropZone {
	files: UploadFile[]
	setFiles: (newFiles: UploadFile[]) => void
}

const DropZone: FC<IDropZone> = ({ files, setFiles }) => {
	const { t } = useLocalization()

	return (
		<Upload.Dragger
			accept=".csv,.xlsx,.xls"
			fileList={files}
			onRemove={() => setFiles([])}
			beforeUpload={file => {
				setFiles([file])
				return false
			}}
			maxCount={1}
			listType="text"
		>
			<p className="ant-upload-drag-icon">
				<InboxOutlined />
			</p>
			<p className="ant-upload-text">{t('placeholders.upload')}</p>
		</Upload.Dragger>
	)
}

export default DropZone
